import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["src"]

import { computed } from 'vue'
import { UiMenuFilterTrigger, UiMenuTriggerTheme } from '@klausapp/ui-kit'
import { getTicketStatusLabel } from '@/modules/shared/TicketContent/utils/ticketStatus.util'

import i18n from '@/i18n'
import IntelligenceIcon from '@/assets/intelligence-icon.svg'
import BotIcon from '@/assets/bot.svg'
import { formatDateIntl } from '@/utils/date'
import { type Condition, type FilterItemValue, FilterValueType } from './types'


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterTrigger',
  props: {
    tippyShown: { type: Boolean },
    description: {},
    activeFilter: { type: Boolean },
    disabled: { type: Boolean },
    intelligenceIcon: { type: Boolean },
    botIcon: { type: Boolean },
    filterLabel: {},
    selectedCondition: {},
    emojiSrc: {},
    value: {},
    valueType: {},
    allSelectedPlaceholder: {},
    forceShowRemoveButton: { type: Boolean },
    forceHideRemoveButton: { type: Boolean },
    showAddSimilarButton: { type: Boolean },
    error: { type: Boolean },
    suffix: {}
  },
  emits: ["remove", "add"],
  setup(__props: any) {

const props = __props



const hasValue = computed(() => {
  if (Array.isArray(props.value)) return !!props.value.length

  return !!props.value
})

const showCondition = computed(() => {
  return props.selectedCondition.label && props.activeFilter
})

const condition = computed(() => {
  return props.selectedCondition.valueRequired ? props.selectedCondition.label : i18n.t('universal.equals')
})

const getSelectedValuesLabel = computed(() => {
  if (!props.value) return props.allSelectedPlaceholder || ''
  if (props.valueType === FilterValueType.Date) return formatDateIntl(props.value as string, { dateStyle: 'medium' })
  if (Array.isArray(props.value)) {
    if (!props.value.length && props.allSelectedPlaceholder) return props.allSelectedPlaceholder
    const labels = props.value.map((v) => v.label || v.value || v)
    return labels.length === 1 ? getTicketStatusLabel(labels[0]) : i18n.t('universal.items_selected', labels.length)
  }
  return props.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiMenuFilterTrigger), {
    size: "md-wide",
    "tooltip-content": 
      _ctx.tippyShown ? (props.disabled ? _ctx.$t('conversations.filters.form.downgraded_filter_tooltip') : _ctx.description) : null
    ,
    "data-testid": "active-filter",
    "can-remove": (_ctx.activeFilter || _ctx.forceShowRemoveButton) && !_ctx.forceHideRemoveButton,
    "can-add": _ctx.activeFilter && _ctx.showAddSimilarButton,
    "show-chevron": false,
    theme: _unref(UiMenuTriggerTheme).Blue,
    active: _ctx.activeFilter && !props.disabled,
    onRemove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove'))),
    onAdd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('add')))
  }, _createSlots({
    label: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.filterLabel), 1 /* TEXT */)
    ]),
    default: _withCtx(() => [
      (!props.selectedCondition.valueRequired)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(props.selectedCondition.label), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
        : (_ctx.emojiSrc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.emojiSrc,
              class: "mx-1 h-4 w-4"
            }, null, 8 /* PROPS */, _hoisted_1))
          : (getSelectedValuesLabel.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                class: _normalizeClass(["truncate whitespace-nowrap text-xs font-medium", [hasValue.value || props.allSelectedPlaceholder ? 'text-active-primary' : 'text-gray-50']])
              }, _toDisplayString(_ctx.suffix ? _ctx.$t(`${_ctx.suffix}`, { value: getSelectedValuesLabel.value }) : getSelectedValuesLabel.value), 3 /* TEXT, CLASS */))
            : _createCommentVNode("v-if", true)
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (props.intelligenceIcon || props.botIcon)
      ? {
          name: "icon",
          fn: _withCtx(() => [
            (props.intelligenceIcon)
              ? (_openBlock(), _createBlock(_unref(IntelligenceIcon), {
                  key: 0,
                  class: "h-[14px] shrink-0"
                }))
              : (props.botIcon)
                ? (_openBlock(), _createBlock(_unref(BotIcon), {
                    key: 1,
                    class: "h-[16px] shrink-0"
                  }))
                : _createCommentVNode("v-if", true)
          ]),
          key: "0"
        }
      : undefined,
    (showCondition.value)
      ? {
          name: "condition",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(condition.value), 1 /* TEXT */)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["tooltip-content", "can-remove", "can-add", "theme", "active"]))
}
}

})